import React, { useRef, useState, Fragment } from 'react'
import injectSheet from 'react-jss'
import { ModalContent } from 'pobble-components/dist/modal'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import FormRow from '../../../../components/common/form-elements/form-row/form-row'
import { apiCrawlLink } from '../../../../common/api/lesson'
import {
  StickyEditor,
  EditorState,
  Controls,
  createStateFromHtml,
  stateToHTML
} from '../../../editor'

const TITLE_MAX_LENGTH = 50
const URL_MAX_LENGTH = 1000
const DESCRIPTION_MAX_LENGTH = 400

const linkSlideFormStyles = ({ COLORS }) => ({
  error: {
    color: COLORS.RED.NORMAL,
    margin: '4px 0 8px'
  }
})

const LinkSlideForm = ({
  classes,
  onSubmit,
  onCancel,
  disableSubmit,
  footer,
  defaultValues = {}
}) => {
  const formRef = useRef(null)
  const [status, setStatus] = useState(null)
  const [editorState, setEditorState] = useState(
    defaultValues.htmlText
      ? createStateFromHtml(defaultValues.htmlText)
      : EditorState.createEmpty()
  )

  return (
    <form
      ref={formRef}
      onSubmit={e => {
        e.preventDefault()
        setStatus('pending')

        if (defaultValues.url === formRef.current.elements.url.value) {
          onSubmit({
            title: formRef.current.elements.title.value,
            text: editorState.getCurrentContent().getPlainText(),
            htmlText: stateToHTML(editorState)
          })
        } else {
          apiCrawlLink(
            { url: formRef.current.elements.url.value },
            { include: 'link.image' }
          )
            .then(res => {
              onSubmit({
                title: formRef.current.elements.title.value,
                linkId: res.data.link.id,
                text: editorState.getCurrentContent().getPlainText(),
                htmlText: stateToHTML(editorState)
              })
            })
            .catch(e => setStatus('error'))
        }
      }}
      className="metrics__slide-form">
      <ModalContent>
        <div className={classes.formHolder}>
          <FormRow first>
            <FormLabel small htmlFor="createLinkSlideTitle">
              What’s the website link?
            </FormLabel>
            <FormInput
              defaultValue={defaultValues.url || ''}
              placeholder="eg. https://www.pobble.com"
              required
              type="url"
              name="url"
              id="createLinkSlideTitle"
              autoFocus={true}
              maxLength={URL_MAX_LENGTH}
            />
            {status === 'error' && (
              <p className={classes.error}>
                Sorry, we couldn't process this url
              </p>
            )}
          </FormRow>
          <FormRow>
            <FormLabel small htmlFor="createLinkSlideTitle">
              Give your link a title
            </FormLabel>
            <FormInput
              defaultValue={defaultValues.title || ''}
              placeholder="eg. Synonyms video"
              required
              name="title"
              id="createLinkSlideTitle"
              maxLength={TITLE_MAX_LENGTH}
            />
          </FormRow>
          <FormRow>
            <FormLabel small spaceBetween htmlFor="resourceDescription">
              Description (optional)
            </FormLabel>
            <StickyEditor
              maxLength={DESCRIPTION_MAX_LENGTH}
              placeholder="Resource description"
              controls={
                <Fragment>
                  <Controls.Bold />
                  <Controls.Italic />
                  <Controls.Underline />
                  <Controls.Separator />
                  <Controls.UnorderedList />
                  <Controls.OrderedList />
                </Fragment>
              }
              editorState={editorState}
              onChange={newState => {
                setEditorState(newState)
              }}
            />
          </FormRow>
        </div>
      </ModalContent>
      {footer({ status })}
    </form>
  )
}

export default injectSheet(linkSlideFormStyles)(LinkSlideForm)
